import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ProjectMetaState {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    genre: string | undefined;
    currentStoryId: string | undefined;
    createdAt: string | undefined;
    updatedAt: string | undefined;
    isLoading: boolean;
    error: Error | null;
}

interface ProjectStore extends ProjectMetaState {
    activeProjectId: string | null;
    activeStoryId: string | null;
    activeChapterId: string | null;
    setActiveProject: (id: string | null) => void;
    setActiveStory: (id: string | null) => void;
    setActiveChapter: (id: string | null) => void;
    setProjectMeta: (meta: ProjectMetaState) => void;
}

export const useProjectStore = create<ProjectStore>()(
    persist(
        (set) => ({
            activeProjectId: null,
            activeStoryId: null,
            activeChapterId: null,
            id: undefined,
            name: undefined,
            description: undefined,
            genre: undefined,
            currentStoryId: undefined,
            createdAt: undefined,
            updatedAt: undefined,
            isLoading: false,
            error: null,
            setActiveProject: (id) => set({ activeProjectId: id }),
            setActiveStory: (id) => set({ activeStoryId: id }),
            setActiveChapter: (id) => set({ activeChapterId: id }),
            setProjectMeta: (meta) => set((state) => ({ ...state, ...meta })),
        }),
        { 
            name: 'active-project',
            // Only persist active IDs, others are transient from hook
            partialize: (state) => ({ 
                activeProjectId: state.activeProjectId, 
                activeStoryId: state.activeStoryId,
                activeChapterId: state.activeChapterId
            }),
        }
    )
);
